@if (order$ | async; as order) {
  <div class="products-section">
    <div class="section-header">
      <h2 class="section-title">Check Scheduled Delivery Dates at Line item</h2>
      <div class="filter-dropdown" [formGroup]="detailsForm">
        <label class="filter-label">{{ 'knbrOrderDetails.label.filterByStatus' | cxTranslate }}</label>
        <ng-select formControlName="statusFilter" [items]="lineItemstatuses" bindLabel="Text" bindValue="Key"
          placeholder="All" [searchable]="false" [clearable]="false" (change)="statusChange($event)">
        </ng-select>
      </div>
    </div>
    @if (this.inlineOrders) {
      <div class="product-list">
        @for (item of this.inlineOrders; track item; let i = $index) {
          <div class="product-card"
            [ngClass]="{ 'highlight-card': item.showLineItem }">
            @if (item.showLineItem === true) {
              <div>
                <!-- Product Header -->
                <div class="product-header">
                  <div class="product-info">
                    <div [ngClass]="{ 'unconsigned-item': !item.consignmentEntry }">
                      @if (item.product.showInCatalog === 'Yes') {
                        <a [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl" cxModal="dismiss" tabindex="-1"
                          >
                          <cx-media [container]="item.product?.images" format="product" class="products-image"></cx-media>
                        </a>
                      }
                      @if (item.product.showInCatalog !== 'Yes') {
                        <a tabindex="-1">
                          <cx-media [container]="item.product?.images" format="product"></cx-media>
                        </a>
                      }
                    </div>
                    <div class="product-details">
                      <div class="product-number">{{ item.product?.code }}</div>
                      @if (item.product?.name) {
                        <div>
                          @if (item.product.showInCatalog === 'Yes') {
                            <a class="product-name" [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
                              cxModal="dismiss">
                              <b>{{ item.product?.name }}</b>
                            </a>
                          }
                          @if (item.product.showInCatalog !== 'Yes') {
                            <span class="product-name">
                              <b>{{ item.product?.name }}</b>
                            </span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <!-- <button class="submit-case-btn" (click)="navigateToCaseCreation(item.product.code, item.entryNumber)" -->
                  <!-- ngbTooltip="{{createCasetoolTipText}}" triggers="hover" placement="top-right"> -->
                  <!-- <img src="assets/images/create-case-icon.svg" class="icon"> -->
                  <!-- Submit Case -->
                <!-- </button> -->
              </div>
              @if (!(isOrderEditable$ | async)) {
                <table class="products-table">
                  <thead>
                    <tr>
                      <th>{{ 'knbrOrderDetails.label.poNumber2' | cxTranslate}}</th>
                      <th>{{ 'knbrOrderDetails.label.qty' | cxTranslate }}</th>
                      <th>{{ 'knbrOrderDetails.label.plant' | cxTranslate }}</th>
                      <th>{{ 'knbrOrderDetails.label.lineItemStatus' | cxTranslate }}</th>
                      <th>{{ 'knbrOrderDetails.label.openQuantity' | cxTranslate }}</th>
                      <th>{{ 'knbrOrderDetails.label.termsOfDelivery' | cxTranslate }}</th>
                      <th>{{ 'knbrOrderDetails.label.unitNetPrice' | cxTranslate }}</th>
                      <th>{{ 'knbrOrderDetails.label.shipTo' | cxTranslate }}</th>
                      <!-- <th>{{ 'knbrOrderDetails.label.quoteReference' | cxTranslate }}</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ item.purchaseOrderNumber ? item.purchaseOrderNumber : '-' }}</td>
                      <td>{{ item?.quantity?.toLocaleString() }} {{ item.uom }}</td>
                      <td>{{ item.plant }}</td>
                      <td>{{ item.lineItemStatus }}</td>
                      <td>{{ item.openQuantity?.toLocaleString() }} {{ item.uom }}</td>
                      <td>{{ item.incoTerm }}</td>
                      <td>{{ getPriceUnit(order.knbrOrderType, item) }}</td>
                      <td>{{ item?.shipTo }}</td>
                      <!-- <td>
                      <a class="cursor-pointer" (click)="navigateToQuote(item?.quoteRefNumber)">
                        {{ item?.knbrQuoteReference ? item?.knbrQuoteReference : '-' }}
                      </a>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            }
            @if (isOrderEditable$ | async) {
              <knbr-kn-br-edit-order-item [item]="item"
                (inputChange)="onQuantityChange($event)">
              </knbr-kn-br-edit-order-item>
            }
            <ng-container>
              <div ngbAccordion [closeOthers]="true">
                <div ngbAccordionItem [collapsed]="true">
                  <div ngbAccordionHeader class="d-flex">
                    <button ngbAccordionButton class="btn btn-link d-flex justify-content-between">
                      <div class="d-flex mr-3 font-size">Scheduled Delivery Dates</div>
                    </button>
                  </div>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        @if (item && item?.scheduleLines?.length) {
                          <div class="expand-content">
                            <table class="products-table">
                              <thead>
                                <tr>
                                  <th>Scheduled Qty</th>
                                  <th>Scheduled Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (line of item?.scheduleLines; track line) {
                                  <tr>
                                    <td>
                                      {{ line.scheduledQuantity?.toLocaleString() }} {{ line.uom }}
                                    </td>
                                    <td>
                                      {{ line.scheduledDate }}
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        }
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- <div class="shipment-section">
            <label class="section-label"><b>{{'knbrOrderDetails.label.shipments' | cxTranslate }}</b></label>
            <div *ngIf="item?.dropShipment" class="shipment-message">
              <span><i>No information available, please contact customer service</i></span>
            </div>
            <ng-container *ngFor="let consignment of item.shipments">
              <table class="product-table">
                <thead>
                  <tr>
                    <th>{{'knbrOrderDetails.label.qtyShipped' | cxTranslate}}</th>
                    <th>{{'knbrOrderDetails.label.shipDate' | cxTranslate}}</th>
                    <th>{{'knbrOrderDetails.label.status' | cxTranslate}}</th>
                    <th>{{'knbrOrderDetails.label.deliveryNumber' | cxTranslate}}</th>
                    <th>{{'knbrOrderDetails.label.shippingType' | cxTranslate}}</th>
                    <th>{{'knbrOrderDetails.label.carrier' | cxTranslate}}</th>
                    <th>{{'knbrOrderDetails.label.trackingId' | cxTranslate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ consignment.qtyShipped }} {{ item.uom }}</td>
                    <td>{{ consignment.shippedDate }}</td>
                    <td>{{ consignment.shippedStatus }}</td>
                    <td>{{ consignment.deliveryNumber }}</td>
                    <td>{{ consignment.shippingType }}</td>
                    <td>{{ consignment.shipmentCarrier }}</td>
                    <td>
                      <span *ngIf="consignment.trackingId && consignment.trackingUrl; else callNumber">
                        <a class="cx-link" href="{{consignment.trackingUrl}}" target="_blank">
                          {{ consignment.trackingId }}
                        </a>
                      </span>
                      <ng-template #callNumber>
                        <span>{{ 'knbrOrderDetails.label.call' | cxTranslate}}</span>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div> -->
          <!-- Shipments Accordion -->
          <div ngbAccordion [closeOthers]="true">
            <div ngbAccordionItem [collapsed]="true">
              <div ngbAccordionHeader class="d-flex">
                <button ngbAccordionButton class="btn btn-link d-flex justify-content-between">
                  <div class="d-flex mr-3 font-size">
                    {{ 'knbrOrderDetails.label.shipments' | cxTranslate }}
                  </div>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div class="shipment-section">
                      @if (!item?.dropShipment) {
                        <div class="shipment-message">
                          <span class="shipment">No shipments available for this order.</span>
                        </div>
                      }
                      @for (consignment of item.shipments; track consignment) {
                        <table class="products-table table-width">
                          <thead>
                            <tr>
                              <th>{{ 'knbrOrderDetails.label.qtyShipped' | cxTranslate }}</th>
                              <th>{{ 'knbrOrderDetails.label.shipDate' | cxTranslate }}</th>
                              <th>{{ 'knbrOrderDetails.label.status' | cxTranslate }}</th>
                              <th>{{ 'knbrOrderDetails.label.deliveryNumber' | cxTranslate }}</th>
                              <th>{{ 'knbrOrderDetails.label.shippingType' | cxTranslate }}</th>
                              <th>{{ 'knbrOrderDetails.label.carrier' | cxTranslate }}</th>
                              <th>{{ 'knbrOrderDetails.label.trackingId' | cxTranslate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ consignment.qtyShipped }} {{ item.uom }}</td>
                              <td>{{ consignment.shippedDate }}</td>
                              <td>{{ consignment.shippedStatus }}</td>
                              <td>{{ consignment.deliveryNumber }}</td>
                              <td>{{ consignment.shippingType }}</td>
                              <td>{{ consignment.shipmentCarrier }}</td>
                              <td>
                                @if (consignment.trackingId && consignment.trackingUrl) {
                                  <span>
                                    <a class="cx-link" [href]="consignment.trackingUrl" target="_blank">
                                      {{ consignment.trackingId }}
                                    </a>
                                  </span>
                                } @else {
                                  <span>{{ 'knbrOrderDetails.label.call' | cxTranslate }}</span>
                                }
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      }
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
}
<div class="actions">
  <button type="button" class="btn-action" (click)="goBack()">
    {{ 'knbrOrderDetails.actions.backOrderHistory' | cxTranslate }}
  </button>
</div>
</div>
}
<ng-container>
  @if (isOrderEditable$ | async) {
    <kn-br-add-products (inputChange)="onInputChange($event)">
    </kn-br-add-products>
  }</ng-container>